<template>
    <main class="news-v2" role="main">
        <portal to="ariane">
            <div class="tbv2-page-title">
                <router-link to="/news" class="tbv2-crumb">{{ $t('news.page.title') }}</router-link>
                <span class="tbv2-sep">/</span>
                <span class="tbv2-current">{{ $t('news.page.new') }}</span>
            </div>
        </portal>

        <header class="news-hero">
            <router-link to="/news" class="news-back">
                <i class="fal fa-arrow-left"></i>
                <span>{{ $t('common.back') }}</span>
            </router-link>
            <h1 class="news-hero-title">{{ $t('news.page.new') }}</h1>
        </header>

        <NewsForm
            mode="create"
            :categories="categoriesList"
            :busy-action="busyAction"
            @submit="onSubmit"
            @cancel="goBack"
        />
    </main>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import NewsForm from '@/components/News/NewsForm.vue'

export default {
    name: 'NewsCreate',
    components: { NewsForm },
    data() {
        return {
            busyAction: null
        }
    },
    computed: {
        ...mapState('news', {
            categories: (state) => state.categories
        }),
        categoriesList() {
            if (!this.categories) return []
            return Array.isArray(this.categories)
                ? this.categories
                : this.categories.data || []
        }
    },
    created() {
        this.getCategories().catch(() => {})
    },
    methods: {
        ...mapActions('news', [
            'getCategories',
            'createArticle',
            'publishArticle'
        ]),
        goBack() {
            this.$router.push({ name: 'News' })
        },
        async onSubmit({ action, payload }) {
            if (this.busyAction) return
            this.busyAction = action
            try {
                const response = await this.createArticle(payload)
                const created =
                    (response && response.data && response.data.article) ||
                    null
                if (action === 'publish' && created && created.id) {
                    await this.publishArticle(created.id)
                }
                this.$store.dispatch('toast', {
                    type: 'success',
                    title: this.$t(
                        action === 'publish'
                            ? 'news.actions.publish'
                            : 'news.actions.save_draft'
                    )
                })
                if (created && created.id) {
                    this.$router.push({
                        name: 'NewsEdit',
                        params: { id: created.id }
                    })
                } else {
                    this.$router.push({ name: 'News' })
                }
            } catch (err) {
                this.$store.dispatch('dispatchError', err)
            } finally {
                this.busyAction = null
            }
        }
    }
}
</script>

<style scoped>
.news-v2 {
    width: 100%;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.news-hero {
    margin-bottom: var(--v2-space-6);
}

.news-back {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: var(--v2-text-xs-size);
    color: var(--v2-text-3);
    text-decoration: none !important;
    margin-bottom: 10px;
    transition: color var(--v2-transition-fast);
}

.news-back:hover {
    color: var(--v2-primary);
}

.news-hero-title {
    margin: 0;
    font-size: 1.75rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.15;
}

@media (max-width: 900px) {
    .news-v2 {
        padding: 16px 18px 32px;
    }
}
</style>
